module.exports = "https://cdn.redage.net/src/views/player/help/images/gang2.jpg";